<template>
<div class="batch-edit">
    <div class="title">已安装列表回传管理</div>
    
    <el-form class="detail" :model="formData" label-width="180px" ref="formRef">
        <!-- 全量包名回传复选框 -->
        <el-form-item class="all-callback-item">
            <el-checkbox v-model="formData.isAllCallback">回传全部包名</el-checkbox>
        </el-form-item>

        <!-- 包名回传列表 -->
        <div v-if="!formData.isAllCallback" class="package-list">
            <div 
                v-for="(item, index) in formData.packageList" 
                :key="item.id" 
                class="package-row"
            >
                <div class="row-number">编号{{ formatNumber(index + 1) }}</div>
                
                <div class="row-content">
                    <el-form-item 
                        label="明文包名" 
                        :prop="`packageList.${index}.plaintextPackageName`"
                        :rules="[{ required: true, message: '请输入明文包名', trigger: 'blur' }]"
                        class="form-item-inline"
                        label-width="90px"
                    >
                        <el-input 
                            v-model="item.plaintextPackageName" 
                            placeholder="请输入明文包名"
                            style="width: 220px"
                        ></el-input>
                    </el-form-item>

                    <el-form-item 
                        label="映射ID" 
                        :prop="`packageList.${index}.packageNameMappingId`"
                        class="form-item-inline"
                        label-width="80px"
                    >
                        <el-input 
                            v-model="item.packageNameMappingId" 
                            placeholder="明文回传也需填写明文包名"
                            style="width: 220px"
                        ></el-input>
                    </el-form-item>

                    <el-form-item 
                        label="操作系统" 
                        :prop="`packageList.${index}.operatingSystem`"
                        :rules="[{ required: true, message: '请选择操作系统', trigger: 'change' }]"
                        class="form-item-inline"
                        label-width="90px"
                    >
                        <el-select 
                            v-model="item.operatingSystem" 
                            placeholder="请选择操作系统"
                            style="width: 220px"
                        >
                            <el-option label="Android" value="Android"></el-option>
                            <el-option label="iOS" value="iOS"></el-option>
                            <el-option label="鸿蒙" value="鸿蒙"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item 
                        label="是否生效" 
                        :prop="`packageList.${index}.isEffective`"
                        class="form-item-inline"
                        label-width="90px"
                    >
                        <el-checkbox v-model="item.isEffective"></el-checkbox>
                    </el-form-item>
                </div>

                <el-button 
                    type="danger" 
                    size="small" 
                    @click="deleteRow(index)"
                    class="delete-btn"
                >删除</el-button>
            </div>

            <!-- 添加按钮 -->
            <el-button 
                type="primary" 
                @click="addRow"
                class="add-btn"
            >添加</el-button>
        </div>
    </el-form>

    <!-- 底部按钮 -->
    <div class="footer-buttons">
        <el-button type="primary" @click="handleSave">保存</el-button>
        <el-button type="danger" @click="handleReturn">返回</el-button>
    </div>
</div>
</template>

<script>
import {sspApi} from '@/api';
import _ from 'lodash'

export default {
    data: function () {
        return {
            formData: {
                isAllCallback: false, // 是否全量回传
                packageList: [] // 包名列表
            },
            backupPackageList: [], // 备份的包名列表，用于恢复
            nextId: 1 // 用于生成唯一ID
        }
    },
    created: function() {
        // 加载数据回显
        this.loadData();
    },
    watch: {
        'formData.isAllCallback': function(newVal) {
            if (newVal) {
                // 勾选全量回传：备份当前数据并清空列表
                this.backupPackageList = _.cloneDeep(this.formData.packageList);
                this.formData.packageList = [];
            } else {
                // 取消勾选全量回传：恢复之前的数据
                if (this.backupPackageList.length > 0) {
                    this.formData.packageList = _.cloneDeep(this.backupPackageList);
                    this.backupPackageList = [];
                } else if (this.formData.packageList.length === 0) {
                    // 如果没有备份数据，添加一行空数据
                    this.addRow();
                }
            }
        }
    },
    methods: {
        // 加载数据
        loadData: function() {
            const accountId = this.$store.state.accountInfo?.id;
            if (!accountId) {
                this.$notify.error({ title: '错误', message: '无法获取账户信息' });
                return;
            }
            
            window.console.log('Loading data for accountId:', accountId);
            
            // 先检查是否为全量回传
            sspApi.isFullFeedback({
                params: {
                    accountId: accountId
                }
            }).then((response) => {
                window.console.log('isFullFeedback response:', response);
                
                // 判断返回结果：1表示全量回传，0表示正常
                let isFull = false;
                if (typeof response === 'number') {
                    isFull = response === 1;
                } else if (typeof response === 'string') {
                    isFull = response === '1' || response === 'true';
                } else if (typeof response === 'object') {
                    // 支持多种可能的字段名
                    isFull = response.isFullFeedback === 1 || 
                             response.isFullFeedback === '1' ||
                             response.isFull === 1 ||
                             response.isFull === '1' ||
                             response.fullFeedback === 1 ||
                             response.fullFeedback === '1' ||
                             response === true;
                }
                
                if (isFull) {
                    // 全量回传，勾选复选框并清空包名列表
                    this.formData.isAllCallback = true;
                    this.formData.packageList = [];
                    window.console.log('Is full feedback, checked checkbox');
                    return;
                }
                
                // 不是全量回传，继续加载包名数据
                this.loadPackageData(accountId);
            }).catch((error) => {
                window.console.error('isFullFeedback API error:', error);
                // 如果检查全量回传的接口失败，继续加载包名数据
                this.loadPackageData(accountId);
            });
        },
        // 加载包名数据
        loadPackageData: function(accountId) {
            sspApi.getAccountAppPackageDetails({
                params: {
                    accountId: accountId
                }
            }).then((response) => {
                window.console.log('API response:', response);
                window.console.log('Response type:', typeof response);
                window.console.log('Is array:', Array.isArray(response));
                
                // 处理返回的数据 - 支持多种响应格式
                let data = response;
                if (response && response.data !== undefined) {
                    data = response.data;
                }
                
                if (data) {
                    // 如果直接返回数组
                    if (Array.isArray(data)) {
                        window.console.log('Response is array, length:', data.length);
                        this.formData.isAllCallback = false;
                        if (data.length > 0) {
                            this.formData.packageList = this.normalizeData(data);
                            // 更新 nextId
                            if (this.formData.packageList.length > 0) {
                                const maxId = Math.max(...this.formData.packageList.map(item => item.id || 0), 0);
                                this.nextId = maxId + 1;
                            }
                            window.console.log('Normalized packageList:', this.formData.packageList);
                        } else {
                            this.formData.packageList = [];
                        }
                        return;
                    }
                    
                    // 检查是否全量回传
                    if (data.isAllCallbacked || data.isAllCallback) {
                        window.console.log('Is all callbacked');
                        this.formData.isAllCallback = true;
                        this.formData.packageList = [];
                    } else {
                        this.formData.isAllCallback = false;
                        
                        // 处理包名列表数据 - 尝试多种可能的字段名
                        let rawList = data.list || data.data || data.packageList || data.items || [];
                        window.console.log('Raw list:', rawList);
                        window.console.log('Raw list is array:', Array.isArray(rawList));
                        window.console.log('Raw list length:', rawList.length);
                        
                        if (Array.isArray(rawList) && rawList.length > 0) {
                            this.formData.packageList = this.normalizeData(rawList);
                            // 更新 nextId，确保新添加的行不会冲突
                            if (this.formData.packageList.length > 0) {
                                const maxId = Math.max(...this.formData.packageList.map(item => item.id || 0), 0);
                                this.nextId = maxId + 1;
                            }
                            window.console.log('Normalized packageList:', this.formData.packageList);
                        } else {
                            // 如果没有数据，不自动添加空行，只显示添加按钮
                            this.formData.packageList = [];
                            window.console.log('No package list data found');
                        }
                    }
                } else {
                    window.console.log('No response data');
                    this.formData.packageList = [];
                }
            }).catch((error) => {
                window.console.error('API error:', error);
                window.console.error('Error details:', error.response || error.message);
                // 显示错误提示
                this.$notify.error({ 
                    title: '加载失败', 
                    message: '无法加载数据，请稍后重试' 
                });
            });
        },
        // 标准化数据字段名
        normalizeData: function(dataList) {
            if (!Array.isArray(dataList)) {
                return [];
            }
            let tempId = this.nextId;
            return dataList.map((item, index) => {
                // 字段映射和标准化
                let osValue = item.operatingSystem || item.os || '';
                // 标准化操作系统值：统一转换为 Android、iOS 或鸿蒙
                if (osValue !== null && osValue !== undefined && osValue !== '') {
                    osValue = String(osValue).trim();
                    // 处理数字映射：33 -> Android, 32 -> iOS, 39 -> 鸿蒙
                    if (osValue === '33' || osValue === 33) {
                        osValue = 'Android';
                    } else if (osValue === '32' || osValue === 32) {
                        osValue = 'iOS';
                    } else if (osValue === '39' || osValue === 39) {
                        osValue = '鸿蒙';
                    } else if (osValue.toLowerCase() === 'android' || osValue.toLowerCase() === 'and') {
                        osValue = 'Android';
                    } else if (osValue.toLowerCase() === 'ios' || osValue.toLowerCase() === 'iphone') {
                        osValue = 'iOS';
                    } else if (osValue === 'harmonyos' || osValue === 'harmony') {
                        osValue = '鸿蒙';
                    }
                } else {
                    osValue = '';
                }
                
                // 包名映射ID
                let mappingId = item.appPackageId || item.packageNameMappingId || '';
                
                // 是否生效：优先检查 valid 字段，然后检查 isEffective 和 effective 字段
                let isEffective = true;
                // 优先处理 valid 字段（接口返回的字段）
                if (item.valid !== undefined && item.valid !== null) {
                    if (typeof item.valid === 'boolean') {
                        isEffective = item.valid;
                    } else if (typeof item.valid === 'string') {
                        isEffective = item.valid === 'true' || item.valid === '1' || item.valid === '是';
                    } else if (typeof item.valid === 'number') {
                        isEffective = item.valid === 1;
                    }
                } else if (item.isEffective !== undefined && item.isEffective !== null) {
                    if (typeof item.isEffective === 'boolean') {
                        isEffective = item.isEffective;
                    } else if (typeof item.isEffective === 'string') {
                        isEffective = item.isEffective === '是' || item.isEffective === 'true' || item.isEffective === '1' || item.isEffective === 'True';
                    } else if (typeof item.isEffective === 'number') {
                        isEffective = item.isEffective === 1;
                    }
                } else if (item.effective !== undefined && item.effective !== null) {
                    // 兼容 effective 字段
                    if (typeof item.effective === 'boolean') {
                        isEffective = item.effective;
                    } else if (typeof item.effective === 'string') {
                        isEffective = item.effective === '是' || item.effective === 'true' || item.effective === '1' || item.effective === 'True';
                    } else if (typeof item.effective === 'number') {
                        isEffective = item.effective === 1;
                    }
                }
                
                // 使用 item.id 如果存在，否则使用临时ID
                let itemId = item.id;
                if (!itemId) {
                    itemId = tempId++;
                }
                
                return {
                    id: itemId,
                    plaintextPackageName: item.appPackage || item.plaintextPackageName || '',
                    packageNameMappingId: mappingId,
                    operatingSystem: osValue,
                    isEffective: isEffective
                };
            });
        },
        // 格式化编号（01, 02, 03...）
        formatNumber: function(num) {
            return String(num).padStart(2, '0');
        },
        // 添加一行
        addRow: function() {
            this.formData.packageList.push({
                id: this.nextId++,
                plaintextPackageName: '',
                packageNameMappingId: '',
                operatingSystem: '',
                isEffective: true // 默认勾选
            });
        },
        // 删除一行
        deleteRow: function(index) {
            this.formData.packageList.splice(index, 1);
        },
        // 验证是否有重复行
        validateDuplicates: function() {
            const list = this.formData.packageList;
            for (let i = 0; i < list.length; i++) {
                for (let j = i + 1; j < list.length; j++) {
                    const item1 = list[i];
                    const item2 = list[j];
                    if (
                        item1.plaintextPackageName === item2.plaintextPackageName &&
                        item1.packageNameMappingId === item2.packageNameMappingId &&
                        item1.operatingSystem === item2.operatingSystem &&
                        item1.isEffective === item2.isEffective
                    ) {
                        return {
                            valid: false,
                            message: `第${this.formatNumber(i + 1)}行和第${this.formatNumber(j + 1)}行数据完全相同，请检查`
                        };
                    }
                }
            }
            return { valid: true };
        },
        // 保存
        handleSave: function() {
            window.console.log('handleSave called');
            window.console.log('formData:', this.formData);
            window.console.log('formRef:', this.$refs.formRef);
            
            // 如果全量回传，直接保存
            if (this.formData.isAllCallback) {
                window.console.log('Is all callback, showing confirm');
                this.$confirm('确定要保存吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    window.console.log('User confirmed, calling doSave');
                    this.doSave();
                }).catch(() => {
                    window.console.log('User cancelled');
                    // 用户取消
                });
                return;
            }

            // 验证表单
            if (!this.$refs.formRef) {
                window.console.error('formRef is not available');
                this.$notify.error({ title: '错误', message: '表单引用不存在' });
                return;
            }

            this.$refs.formRef.validate((valid) => {
                window.console.log('Form validation result:', valid);
                if (!valid) {
                    this.$notify.error({ title: '验证失败', message: '请检查输入信息' });
                    return;
                }

                // 验证重复行
                const duplicateCheck = this.validateDuplicates();
                if (!duplicateCheck.valid) {
                    this.$notify.error({ title: '验证失败', message: duplicateCheck.message });
                    return;
                }

                // 验证至少有一行有效数据（且已填写必填项）
                if (this.formData.packageList.length === 0) {
                    this.$notify.error({ title: '验证失败', message: '请至少添加一行数据' });
                    return;
                }
                
                const validRows = this.formData.packageList.filter(item => 
                    item.plaintextPackageName && item.plaintextPackageName.trim() && item.operatingSystem
                );
                window.console.log('Valid rows:', validRows.length, 'Total rows:', this.formData.packageList.length);
                if (validRows.length === 0) {
                    this.$notify.error({ title: '验证失败', message: '请至少添加一行完整数据（包含明文包名和操作系统）' });
                    return;
                }

                // 二次确认
                window.console.log('Showing confirm dialog');
                this.$confirm('确定要保存吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    window.console.log('User confirmed, calling doSave');
                    try {
                        this.doSave();
                    } catch (error) {
                        window.console.error('Error in doSave:', error);
                        this.$notify.error({ title: '错误', message: '保存过程中发生错误' });
                    }
                }).catch((err) => {
                    // 用户点击取消时，err 通常是 'cancel'
                    if (err === 'cancel' || err === 'close') {
                        window.console.log('User cancelled');
                    } else {
                        window.console.error('Confirm dialog error:', err);
                    }
                });
            });
        },
        // 执行保存
        doSave: function() {
            try {
                window.console.log('doSave called');
                const accountId = this.$store.state.accountInfo?.id;
                window.console.log('accountId:', accountId);
                if (!accountId) {
                    this.$notify.error({ title: '错误', message: '无法获取账户信息' });
                    return;
                }

                window.console.log('isAllCallback:', this.formData.isAllCallback);
                window.console.log('packageList length:', this.formData.packageList ? this.formData.packageList.length : 0);

                // 准备保存的数据数组
                let saveDataArray = [];

                if (this.formData.isAllCallback) {
                    // 全量回传：传递空数组或特殊标记
                    // 这里可能需要根据后端接口调整
                    saveDataArray = [];
                    window.console.log('All callback mode, empty array');
                } else {
                    // 保存所有数据，转换为后端需要的格式数组
                    window.console.log('Processing packageList:', this.formData.packageList);
                    if (!Array.isArray(this.formData.packageList)) {
                        window.console.error('packageList is not an array:', this.formData.packageList);
                        this.$notify.error({ title: '错误', message: '数据格式错误' });
                        return;
                    }
                    
                    saveDataArray = this.formData.packageList.map((item, index) => {
                        window.console.log(`Processing item ${index}:`, item);
                        // 转换操作系统值：Android -> 33, iOS -> 32, 鸿蒙 -> 39
                        let osValue = item.operatingSystem;
                        if (osValue === 'Android') {
                            osValue = '33';
                        } else if (osValue === 'iOS') {
                            osValue = '32';
                        } else if (osValue === '鸿蒙') {
                            osValue = '39';
                        }
                        
                        // 转换 appPackageId：如果为空则设为 null；非空按字符串原值传递，避免长整型/字符串被 parseInt 丢失
                        let appPackageId = null;
                        if (item.packageNameMappingId !== undefined && item.packageNameMappingId !== null) {
                            const mappingIdStr = String(item.packageNameMappingId).trim();
                            if (mappingIdStr !== '') {
                                appPackageId = mappingIdStr;
                            }
                        }
                        
                        // 转换 valid：true -> 1, false -> 0
                        const valid = item.isEffective ? 1 : 0;
                        
                        return {
                            accountId: accountId,
                            appPackage: item.plaintextPackageName || '',
                            appPackageId: appPackageId,
                            os: osValue || '',
                            valid: valid
                        };
                    });
                    window.console.log('Save data array:', saveDataArray);
                }

                // 调用API保存，直接传递数组
                window.console.log('Calling savePackageNames with:', saveDataArray);
                this.savePackageNames(saveDataArray, this.formData.isAllCallback).then(() => {
                    window.console.log('Save successful');
                    this.$notify.success({ title: '成功', message: '保存成功' });
                    // 跳转回列表页
                    this.$router.push({ name: 'installedListCallback' }).catch(() => {});
                }).catch((error) => {
                    window.console.error('Save error:', error);
                    this.$rejectAjaxError()(error);
                });
            } catch (error) {
                window.console.error('Error in doSave:', error);
                window.console.error('Error stack:', error.stack);
                this.$notify.error({ title: '错误', message: '保存过程中发生错误：' + (error.message || error) });
            }
        },
        // 保存包名数据（批量保存）
        savePackageNames: function(dataArray, isAllCallback) {
            window.console.log('savePackageNames called with:', dataArray, 'isAllCallback:', isAllCallback);
            const accountId = this.$store.state.accountInfo?.id;
            
            if (isAllCallback) {
                // 全量回传：调用设置全量回传的API，通过 params 传递 accountId
                window.console.log('Calling setAllCallback with accountId:', accountId);
                return sspApi.setAllCallback({ 
                    params: {
                        accountId: accountId
                    }
                });
            } else {
                // 批量保存：直接传递数组
                window.console.log('Calling batchCreatePackageName');
                return sspApi.batchCreatePackageName({ data: dataArray });
            }
        },
        // 返回
        handleReturn: function() {
            this.$router.push({ name: 'installedListCallback' }).catch(() => {});
        }
    }
}
</script>

<style scoped>
.batch-edit {
    padding: 20px;
}

.title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
}

.detail {
    font-size: 14px;
}

.all-callback-item >>> .el-form-item__content {
    margin-left: 0 !important;
    text-align: left;
}

.package-list {
    margin-top: 20px;
}

.package-row {
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 15px;
    background-color: #fafafa;
    position: relative;
    overflow: visible;
    width: 100%;
    box-sizing: border-box;
}

.package-row .row-content {
    padding-right: 90px;
    width: calc(100% - 90px);
}

.row-number {
    font-weight: bold;
    margin-bottom: 15px;
    color: #606266;
    font-size: 14px;
}

.row-content {
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    align-items: flex-start;
    min-width: 0;
    overflow: visible;
    width: 100%;
}

.form-item-inline {
    margin-bottom: 0;
    flex: 0 0 auto;
    margin-right: 0;
    min-width: 0;
}

.form-item-inline {
    display: inline-block !important;
    vertical-align: top;
}

.form-item-inline >>> .el-form-item {
    display: inline-flex !important;
    flex-direction: row !important;
    align-items: center !important;
    flex-wrap: nowrap !important;
    margin-bottom: 0;
    margin-right: 0;
    vertical-align: top;
}

.form-item-inline >>> .el-form-item__label {
    padding-right: 12px;
    white-space: nowrap !important;
    font-size: 14px;
    width: auto !important;
    flex-shrink: 0 !important;
    flex-grow: 0 !important;
    line-height: 40px;
    float: none !important;
    display: inline-block !important;
    vertical-align: middle;
}

.form-item-inline >>> .el-form-item__content {
    margin-left: 0 !important;
    flex: 0 0 auto !important;
    min-width: 220px;
    line-height: 40px;
    float: none !important;
    display: inline-block !important;
    vertical-align: middle;
}

.delete-btn {
    position: absolute;
    right: 15px;
    top: 15px;
}

.add-btn {
    margin-top: 10px;
    margin-bottom: 20px;
}

.footer-buttons {
    margin-top: 30px;
    margin-left: 0;
    text-align: left;
}

.footer-buttons .el-button {
    margin-right: 10px;
}
</style>

